


































# import settings from '@/settings'
import t from '@/utils/tools'

export default {
    name: 'skills'

    props: ['payload', 'deletions']

    watch:
        payload: (new_item, old_item)->
            # console.log "WATCH ", new_item, old_item
            if Object.keys(@payload).length == 0
                @add_skill()

    data: ()->
        min: 0
        max: 10
        false: false
        skill: {
            uid: ''
            name: ''
            skill_type: 'skill'
            slug: ''
            level_waited: 5
            mandatory: false
        }

    methods:
        deep_copy: t.deep_copy

        remove_skill: (index)->
            if @payload[index]['uid'] != ""
                @deletions.push(@payload[index]['uid'])
            # console.log "DELETIONS S : ", @deletions
            if Object.keys(@payload).length > 1
                @payload.splice(index, 1)
            else
                @payload[0].name = ""
                @payload[0].level_waited = 1
                # console.log "FIRST SKILL"

        add_skill: ()->
            @payload.push(@deep_copy(@skill))
        
    beforeMount: ()->
        # console.log "SKILLS COMPONENT : ", @payload
        if Object.keys(@payload).length == 0
            @add_skill()

}

